import { MenuItem, PermissionType } from 'lib-klab-core';

export const CUSTOMER_ACCESS_DENIED_URL = '/login?reason=portal-access';

export function normalizePermission(code: string): string {
  return String(code ?? '').trim().toUpperCase();
}

export function hasCustomerPermission(menu: readonly MenuItem[] | null | undefined, code: string): boolean {
  const expected = normalizePermission(code);
  return expected.startsWith('APP-') && (menu ?? []).some((item) =>
    (normalizePermission(item.code) === expected && customerPermissionRoute(item) !== null) || hasCustomerPermission(item.children, expected),
  );
}

export function customerPermissionRoute(item: MenuItem): string | null {
  const isNavigation = item.permission_type === PermissionType.MenuParent || item.permission_type === PermissionType.MenuItem;
  const route = String(item.route ?? '').trim();
  if (!isNavigation || !normalizePermission(item.code).startsWith('APP-') || !/^\/app\/[^/?#]/.test(route)) return null;
  try {
    const path = decodeURIComponent(route.split(/[?#]/)[0]);
    if (/[\\\s]/.test(path) || path.split('/').some(segment => segment === '.' || segment === '..')) return null;
    return route;
  } catch {
    return null;
  }
}

export function hasCustomerPortalAccess(menu: readonly MenuItem[] | null | undefined): boolean {
  return resolveCustomerEntry(menu) !== CUSTOMER_ACCESS_DENIED_URL;
}

export function resolveCustomerEntry(menu: readonly MenuItem[] | null | undefined): string {
  for (const item of [...(menu ?? [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))) {
    const route = customerPermissionRoute(item);
    if (route) return route;
    const childRoute = resolveCustomerEntry(item.children);
    if (childRoute !== CUSTOMER_ACCESS_DENIED_URL) return childRoute;
  }
  return CUSTOMER_ACCESS_DENIED_URL;
}
